// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CategoriesList_CategoriesList__Rae0i {
  width: 100%;
}
.CategoriesList_CategoriesList__Rae0i .CategoriesList_Title__EBWjU {
  margin: 0 0 20px;
}
.CategoriesList_CategoriesList__Rae0i .CategoriesList_NewCategoryButton__leB5T {
  margin: 0 0 20px;
}
.CategoriesList_CategoriesList__Rae0i .CategoriesList_CategoriesTable__M8ZhZ {
  width: 100%;
  border: 1px solid #dee2e6;
  border-radius: 5px;
}
.CategoriesList_CategoriesList__Rae0i .CategoriesList_CategoriesTable__M8ZhZ th:nth-child(1) {
  width: 20%;
}
.CategoriesList_CategoriesList__Rae0i .CategoriesList_CategoriesTable__M8ZhZ th:nth-child(3) {
  width: 55px;
  text-align: center;
}
.CategoriesList_CategoriesList__Rae0i .CategoriesList_CategoriesTable__M8ZhZ th:nth-child(4) {
  width: 14%;
}
.CategoriesList_CategoriesList__Rae0i .CategoriesList_CategoriesTable__M8ZhZ td:nth-child(3) {
  text-align: center;
}
.CategoriesList_CategoriesList__Rae0i .CategoriesList_CategoriesTable__M8ZhZ td:nth-child(4) {
  text-align: center;
}
.CategoriesList_CategoriesList__Rae0i .CategoriesList_CategoriesTable__M8ZhZ td .CategoriesList_ActionIconButton__FR7zG {
  border: none;
}
.CategoriesList_CategoriesList__Rae0i .CategoriesList_CategoriesTable__M8ZhZ td .CategoriesList_ActionIconButton__FR7zG.CategoriesList_DeleteEventButton___7tRm .CategoriesList_Icon__pa8KE {
  color: #d51919;
  width: 100%;
}
.CategoriesList_CategoriesList__Rae0i .CategoriesList_CategoriesTable__M8ZhZ td .CategoriesList_ActionIconButton__FR7zG.CategoriesList_EditEventButton__tq3Op {
  margin: 0 10px;
}
.CategoriesList_CategoriesList__Rae0i .CategoriesList_CategoriesTable__M8ZhZ td .CategoriesList_ActionIconButton__FR7zG.CategoriesList_EditEventButton__tq3Op .CategoriesList_Icon__pa8KE {
  color: #228be6;
}
.CategoriesList_CategoriesList__Rae0i .CategoriesList_CategoriesTable__M8ZhZ .CategoriesList_ColorCircle__KL2oK {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin: 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/components/CategoriesList/CategoriesList.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;AACI;EACI,gBAAA;AACR;AAEI;EACI,gBAAA;AAAR;AAGI;EACI,WAAA;EACA,yBAAA;EACA,kBAAA;AADR;AAIY;EACI,UAAA;AAFhB;AAKY;EACI,WAAA;EACA,kBAAA;AAHhB;AAMY;EACI,UAAA;AAJhB;AASY;EACI,kBAAA;AAPhB;AAUY;EACI,kBAAA;AARhB;AAWY;EACI,YAAA;AAThB;AAYoB;EACI,cAAA;EACA,WAAA;AAVxB;AAcgB;EACI,cAAA;AAZpB;AAcoB;EACI,cAAA;AAZxB;AAkBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AAhBZ","sourcesContent":[".CategoriesList {\n    width: 100%;\n\n    .Title {\n        margin: 0 0 20px;\n    }\n\n    .NewCategoryButton {\n        margin: 0 0 20px;\n    }\n\n    .CategoriesTable {\n        width: 100%;\n        border: 1px solid #dee2e6;\n        border-radius: 5px;\n\n        th {\n            &:nth-child(1) {\n                width: 20%;\n            }\n\n            &:nth-child(3) {\n                width: 55px;\n                text-align: center;\n            }\n\n            &:nth-child(4) {\n                width: 14%;\n            }\n        }\n\n        td {\n            &:nth-child(3) {\n                text-align: center;\n            }\n\n            &:nth-child(4) {\n                text-align: center;\n            }\n\n            .ActionIconButton {\n                border: none;\n\n                &.DeleteEventButton {\n                    .Icon {\n                        color: #d51919;\n                        width: 100%;\n                    }\n                }\n\n                &.EditEventButton {\n                    margin: 0 10px;\n\n                    .Icon {\n                        color: #228be6;\n                    }\n                }\n            }\n        }\n\n        .ColorCircle {\n            width: 20px;\n            height: 20px;\n            border-radius: 50%;\n            margin: 0 auto;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"CategoriesList": `CategoriesList_CategoriesList__Rae0i`,
	"Title": `CategoriesList_Title__EBWjU`,
	"NewCategoryButton": `CategoriesList_NewCategoryButton__leB5T`,
	"CategoriesTable": `CategoriesList_CategoriesTable__M8ZhZ`,
	"ActionIconButton": `CategoriesList_ActionIconButton__FR7zG`,
	"DeleteEventButton": `CategoriesList_DeleteEventButton___7tRm`,
	"Icon": `CategoriesList_Icon__pa8KE`,
	"EditEventButton": `CategoriesList_EditEventButton__tq3Op`,
	"ColorCircle": `CategoriesList_ColorCircle__KL2oK`
};
export default ___CSS_LOADER_EXPORT___;
